import { useQuery } from '@tanstack/react-query';
import { container } from '@src/container';
import { UniversityService } from '@src/application/universities/usecases';

/**
 * Hook: useUniversities
 * Fetches the list of universities
 *
 * @example
 * const { data: universities, isLoading, error } = useUniversities();
 */
export function useUniversities(skip?: number, limit?: number) {
    const universityService = container.resolve<UniversityService>('UniversityService');

    return useQuery({
        queryKey: ['universities', 'list', { skip, limit }],
        queryFn: async () => {
            try {
                const result = await universityService.listUniversities(skip, limit);
                if (import.meta.env.DEV) {
                    console.log('✅ Universities fetched:', result);
                }
                return result;
            } catch (error) {
                if (import.meta.env.DEV) {
                    console.error('❌ Failed to fetch universities:', error);
                }
                throw error;
            }
        },
        staleTime: 1000 * 60 * 10, // 10 minutes
        gcTime: 1000 * 60 * 30, // Keep in cache for 30 minutes
        refetchOnWindowFocus: false,
        refetchOnMount: true,
    });
}